import { useDamageWaiverApi } from "../api/DamageWaiverApiClient";
import { DamageWaiverFrontendService } from "../services/DamageWaiverFrontendService";

export const useDamageWaiverService = (): DamageWaiverFrontendService =>
  new DamageWaiverFrontendService(useDamageWaiverApi());
